import { render, staticRenderFns } from "./TrainingView.vue?vue&type=template&id=7cffd461&scoped=true"
import script from "./TrainingView.vue?vue&type=script&lang=js"
export * from "./TrainingView.vue?vue&type=script&lang=js"
import style0 from "./TrainingView.vue?vue&type=style&index=0&id=7cffd461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffd461",
  null
  
)

export default component.exports